var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationUnitedKingdom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 202,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.203,
    transform: "matrix(0 1 1 0 0 0)",
    cx: 101,
    cy: 101,
    r: 101
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M64.201 90.934l4.7-4.831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2 91.204a.262.262 0 01-.186-.077.271.271 0 010-.381l4.67-4.83c.105-.101.27-.1.373 0 .104.102.11.267.013.375l-4.7 4.83a.274.274 0 01-.17.083z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M68.901 90.934l-4.7-4.831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9 91.204a.274.274 0 01-.192-.082l-4.67-4.831a.265.265 0 010-.376.268.268 0 01.379 0l4.7 4.83a.277.277 0 010 .382.262.262 0 01-.216.077z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M68.901 90.934l4.7-4.831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9 91.204a.256.256 0 01-.186-.077.277.277 0 010-.381l4.671-4.83a.262.262 0 01.374 0 .259.259 0 010 .375l-4.671 4.83a.274.274 0 01-.187.083z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M73.601 90.934l-4.7-4.831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.601 91.204a.274.274 0 01-.193-.082l-4.67-4.831a.271.271 0 01.012-.374.268.268 0 01.373-.002l4.67 4.83a.265.265 0 010 .382.245.245 0 01-.192.077z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M73.601 90.934l4.694-4.831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.601 91.204a.245.245 0 01-.187-.077.271.271 0 010-.381l4.7-4.83a.268.268 0 01.354.02.271.271 0 01.026.355l-4.7 4.83a.274.274 0 01-.193.083z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M78.295 90.934l-4.694-4.831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.313 91.204a.25.25 0 01-.187-.082l-4.7-4.831a.271.271 0 01.026-.355.268.268 0 01.353-.02l4.7 4.83a.271.271 0 010 .381.256.256 0 01-.192.077z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M78.295 90.934l4.701-4.831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.313 91.204a.262.262 0 01-.187-.077.271.271 0 010-.381l4.671-4.83c.104-.101.269-.1.373 0 .103.102.109.267.012.375l-4.67 4.83a.274.274 0 01-.2.083z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M82.996 90.934l-4.701-4.831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.984 91.204a.274.274 0 01-.193-.082l-4.67-4.831a.265.265 0 010-.376.268.268 0 01.379 0l4.67 4.83a.277.277 0 010 .382.262.262 0 01-.186.077z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M82.996 90.934l4.7-4.831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.984 91.204a.256.256 0 01-.187-.077.277.277 0 010-.381l4.7-4.83a.268.268 0 01.38.375l-4.671 4.83a.274.274 0 01-.222.083z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M87.696 90.934l-4.7-4.831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.696 91.204a.274.274 0 01-.193-.082l-4.7-4.831a.271.271 0 01.013-.374.268.268 0 01.372-.002l4.671 4.83a.271.271 0 010 .382.262.262 0 01-.163.077z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M87.696 90.934l4.694-4.831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.696 91.204a.256.256 0 01-.187-.077.271.271 0 010-.381l4.67-4.83a.268.268 0 01.355.02.271.271 0 01.025.355l-4.7 4.83a.274.274 0 01-.163.083z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M92.39 90.934l-4.694-4.831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.39 91.204a.262.262 0 01-.187-.082l-4.67-4.831a.271.271 0 01.025-.355.268.268 0 01.354-.02l4.7 4.83a.271.271 0 010 .381.256.256 0 01-.222.077z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M92.39 90.934l4.7-4.831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.39 91.204a.262.262 0 01-.187-.077.271.271 0 010-.381l4.671-4.83c.105-.101.27-.1.373 0 .103.102.11.267.013.375l-4.7 4.83a.274.274 0 01-.17.083z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M97.09 90.934l-4.7-4.831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.09 91.204a.274.274 0 01-.192-.082l-4.671-4.831a.265.265 0 010-.376.268.268 0 01.38 0l4.7 4.83a.277.277 0 010 .382.262.262 0 01-.217.077z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M103.811 90.934l4.7-4.831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.81 91.204a.262.262 0 01-.186-.077.271.271 0 010-.381l4.67-4.83c.105-.101.27-.1.373 0 .104.102.11.267.013.375l-4.677 4.83a.274.274 0 01-.192.083z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M108.511 90.934l-4.7-4.831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.51 91.204a.274.274 0 01-.192-.082l-4.67-4.831a.265.265 0 010-.376.268.268 0 01.379 0l4.7 4.83a.277.277 0 010 .382.256.256 0 01-.216.077z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M108.511 90.934l4.7-4.831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.51 91.204a.262.262 0 01-.186-.077.277.277 0 010-.381l4.7-4.83a.268.268 0 01.38.375l-4.671 4.83a.274.274 0 01-.222.083z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M113.211 90.934l-4.7-4.831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.21 91.204a.274.274 0 01-.192-.082l-4.7-4.831a.271.271 0 01.013-.374.268.268 0 01.372-.002l4.671 4.83a.271.271 0 010 .382.262.262 0 01-.163.077z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M113.211 90.934l4.694-4.831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.21 91.204a.256.256 0 01-.186-.077.277.277 0 010-.381l4.7-4.83a.268.268 0 01.354.02.271.271 0 01.026.355l-4.671 4.83a.25.25 0 01-.222.083z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M117.905 90.934l-4.694-4.831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.905 91.204a.274.274 0 01-.187-.082l-4.7-4.831a.271.271 0 010-.376.262.262 0 01.374 0l4.67 4.83a.271.271 0 010 .382.245.245 0 01-.157.077z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M117.905 90.934l4.7-4.831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.905 91.204a.245.245 0 01-.18-.077.265.265 0 010-.381l4.67-4.83a.262.262 0 01.374 0c.1.104.1.27 0 .375l-4.7 4.83a.274.274 0 01-.164.083z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M122.605 90.934l-4.7-4.831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.605 91.204a.25.25 0 01-.186-.082l-4.671-4.831a.259.259 0 010-.376.262.262 0 01.373 0l4.7 4.83a.277.277 0 010 .382.256.256 0 01-.216.077z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M122.605 90.934l4.701-4.831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.605 91.204a.262.262 0 01-.186-.077.271.271 0 010-.381l4.67-4.83c.105-.101.27-.1.373 0 .104.102.11.267.013.375l-4.7 4.83a.274.274 0 01-.17.083z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M127.306 90.934l-4.701-4.831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.306 91.204a.274.274 0 01-.193-.082l-4.671-4.831a.265.265 0 010-.376.268.268 0 01.38 0l4.7 4.83a.277.277 0 010 .382.262.262 0 01-.216.077z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M127.306 90.934l4.7-4.831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.306 91.204a.256.256 0 01-.187-.077.277.277 0 010-.381l4.67-4.83a.262.262 0 01.374 0 .259.259 0 010 .375l-4.67 4.83a.274.274 0 01-.187.083z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M132.006 90.934l-4.7-4.831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.029 91.204a.274.274 0 01-.193-.082l-4.67-4.831a.271.271 0 01.012-.374.268.268 0 01.373-.002l4.67 4.83a.265.265 0 010 .382.245.245 0 01-.192.077z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M132.006 90.934l4.694-4.831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.029 91.204a.256.256 0 01-.187-.077.271.271 0 010-.381l4.7-4.83a.262.262 0 01.374 0c.1.104.1.27 0 .375l-4.67 4.83a.274.274 0 01-.217.083z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M136.7 90.934l-4.694-4.831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.7 91.204a.25.25 0 01-.187-.082l-4.7-4.831a.271.271 0 01.026-.355.268.268 0 01.354-.02l4.67 4.83a.277.277 0 010 .381.256.256 0 01-.163.077z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.112 86.185H58.888a.262.262 0 01-.27-.264c0-.149.121-.27.27-.27h83.224a.27.27 0 01.19.459.262.262 0 01-.19.075z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M62.274 132.12h76.446v2.671H62.274z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.726 135.043H62.274a.263.263 0 01-.263-.264v-2.67c0-.146.118-.264.263-.264h76.452c.145 0 .263.118.263.264v2.676a.263.263 0 01-.263.258zm-76.178-.516h75.904v-2.137H62.548v2.137z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.726 134.797v15.848h-9.155s-6.253-14.205-29.071-14.205-29.07 14.205-29.07 14.205h-9.156v-15.848h76.452z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.726 150.891h-9.155a.28.28 0 01-.245-.158c-.059-.141-6.464-14.052-28.826-14.052-22.362 0-28.767 13.911-28.826 14.052a.28.28 0 01-.245.158h-9.155a.268.268 0 01-.269-.27v-15.848a.27.27 0 01.269-.27h76.452a.268.268 0 01.269.27v15.848c0 .15-.12.27-.269.27zm-8.986-.534h8.712v-15.314H62.548v15.32h8.718c.794-1.579 7.823-14.21 29.24-14.21 21.416 0 28.44 12.649 29.234 14.228v-.024zM59.349 90.934h82.302v2.448H59.349z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.651 93.675H59.325a.293.293 0 01-.292-.294v-2.447c0-.162.131-.294.292-.294h82.326c.161 0 .292.132.292.294v2.436a.296.296 0 01-.292.305zm-82.01-.587h81.73v-1.86H59.629l.012 1.86z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7816B",
    d: "M97.19 84.935l3.31-2.295 3.31 2.295v5.999h-6.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.81 91.204h-6.62a.27.27 0 01-.27-.27v-5.999a.27.27 0 01.118-.223l3.31-2.295a.285.285 0 01.304 0l3.31 2.295a.27.27 0 01.117.223v5.999c0 .149-.12.27-.268.27zm-6.358-.534h6.096v-5.594l-3.048-2.113-3.048 2.113v5.594z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.19 89.63a.262.262 0 01-.27-.263v-6.034a.27.27 0 01.121-.267.267.267 0 01.291 0 .27.27 0 01.12.267v6.034a.263.263 0 01-.263.264zM103.81 89.63a.263.263 0 01-.262-.263v-6.034a.27.27 0 01.12-.267.267.267 0 01.291 0 .27.27 0 01.12.267v6.034a.265.265 0 01-.268.264zM100.5 82.91a.275.275 0 01-.269-.27v-1.667a.27.27 0 11.537 0v1.667a.275.275 0 01-.268.27zM10.321 132.109V116.43c18.684-3.128 37.368-26.037 37.368-26.037l-1.028 4.513s-19.028 21.618-36.352 23.631",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.321 132.414a.293.293 0 01-.292-.294v-15.683c0-.145.104-.268.245-.294 18.363-3.07 37.012-25.702 37.199-25.925a.297.297 0 01.356-.083.306.306 0 01.152.33l-1.022 4.513a.253.253 0 01-.07.129c-.187.217-19.104 21.512-36.276 23.695v13.307a.294.294 0 01-.292.305zm.292-15.736v1.526c16.506-2.149 34.711-22.228 35.791-23.437l.748-3.276c-3.72 4.285-20.173 22.299-36.539 25.187z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.973 132.39a.262.262 0 01-.263-.27v-14.873a.269.269 0 01.532 0v14.862a.265.265 0 01-.269.282zM22.016 132.39a.262.262 0 01-.269-.27v-17.438a.269.269 0 01.532 0v17.427a.265.265 0 01-.263.282zM28.328 132.39a.268.268 0 01-.269-.27v-21.142a.27.27 0 11.537 0v21.13a.27.27 0 01-.268.282zM34.64 132.39a.262.262 0 01-.263-.27v-25.837a.269.269 0 01.53 0v25.826a.265.265 0 01-.268.282zM54.777 53.286a.27.27 0 01-.269-.264v-5.33a.27.27 0 11.537 0v5.33a.27.27 0 01-.268.264zM54.03 54.43h1.494l6.481 26.79H47.55z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.005 81.507h-14.45a.289.289 0 01-.286-.358l6.475-26.783a.298.298 0 01.286-.229h1.512c.136 0 .253.096.28.23l6.475 26.782a.289.289 0 01-.292.358zm-14.083-.587h13.71l-6.335-26.196h-1.04L47.922 80.92z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M54.036 52.423h1.489v2.007h-1.489z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.542 54.724h-1.483a.293.293 0 01-.292-.293v-2.008c0-.162.13-.293.292-.293h1.483c.161 0 .292.131.292.293v2.008c0 .162-.13.293-.292.293zm-1.168-.587h.9v-1.42h-.9v1.42z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7816B",
    d: "M57.936 80.34v-6.346l-3.159-5.341-3.159 5.341v6.345h-3.036v50.778h12.39V80.339z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.972 131.387H48.588a.27.27 0 01-.269-.27V80.339a.265.265 0 01.269-.264h2.768V74c0-.047.011-.094.035-.135l3.158-5.341a.274.274 0 01.456 0l3.159 5.341a.271.271 0 01.035.135v6.08h2.773c.145 0 .263.12.263.265v50.778a.27.27 0 01-.263.264zm-12.121-.54h11.852V80.609h-2.767a.275.275 0 01-.269-.27v-6.274l-2.92-4.89-2.918 4.89v6.274c0 .15-.12.27-.27.27h-2.767l.059 50.238z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.972 85.258H48.588a.268.268 0 01-.265-.12.271.271 0 010-.294.268.268 0 01.265-.12h12.384a.27.27 0 010 .534zM52.588 94.937h-1.956v-6.363c0-.546.98-1.426.98-1.426s.976.88.976 1.426v6.363zM55.758 94.937H53.79v-6.363c0-.546.981-1.426.981-1.426s.981.88.981 1.426l.006 6.363zM58.923 94.937h-1.956v-6.363c0-.546.975-1.426.975-1.426s.98.88.98 1.426v6.363zM52.588 106.87h-1.956v-6.392c0-.54.98-1.427.98-1.427s.976.887.976 1.427v6.392zM55.758 106.87H53.79v-6.392c0-.54.981-1.427.981-1.427s.981.887.981 1.427l.006 6.392zM58.923 106.87h-1.956v-6.392c0-.54.975-1.427.975-1.427s.98.887.98 1.427v6.392zM52.588 118.755h-1.956v-6.368c0-.546.98-1.426.98-1.426s.976.88.976 1.426v6.368zM55.758 118.755H53.79v-6.368c0-.546.981-1.426.981-1.426s.981.88.981 1.426l.006 6.368zM58.923 118.755h-1.956v-6.368c0-.546.975-1.426.975-1.426s.98.88.98 1.426v6.368zM60.528 122.271H49.026a.27.27 0 01-.269-.264.275.275 0 01.269-.27h11.502a.275.275 0 01.269.27.27.27 0 01-.269.264zM46.527 60.612l2.954 11.31h-5.908z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.481 72.24h-5.908a.303.303 0 01-.234-.118.295.295 0 01-.047-.253l2.92-11.31a.304.304 0 01.584 0l2.954 11.31a.283.283 0 01-.053.253.292.292 0 01-.216.117zm-5.529-.588h5.167l-2.575-9.867-2.592 9.867z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7816B",
    d: "M44.635 71.922l.123 18.853 1.127 3.017v37.325h3.626V93.41l-.882-1.978v-19.51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.51 131.387h-3.625a.275.275 0 01-.269-.27V93.839l-1.103-2.97a.266.266 0 010-.094l-.129-18.853c0-.073.03-.142.082-.194a.268.268 0 01.187-.076h3.993a.27.27 0 01.269.27v19.452l.858 1.931a.313.313 0 010 .106v37.706a.275.275 0 01-.262.27zm-3.357-.54h3.089V93.469l-.858-1.925a.384.384 0 010-.111V72.186h-3.457l.123 18.536 1.11 2.97a.295.295 0 010 .094l-.007 37.06z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.629 84.442h-3.912a.268.268 0 01-.265-.12.271.271 0 010-.293.268.268 0 01.265-.121h3.912a.268.268 0 01.265.12.271.271 0 010 .293.268.268 0 01-.265.121zM49.51 94.056h-3.625a.268.268 0 01-.265-.12.271.271 0 010-.293.268.268 0 01.265-.12h3.626a.268.268 0 01.265.12.271.271 0 010 .293.268.268 0 01-.265.12zM63.027 60.612l-2.954 11.31h5.909z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.982 72.24h-5.91a.291.291 0 01-.227-.118.283.283 0 01-.052-.253l2.954-11.31a.304.304 0 01.584 0l2.954 11.31a.3.3 0 01-.303.37zm-5.53-.588h5.15l-2.575-9.867-2.575 9.867z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7816B",
    d: "M64.919 71.922l-.123 18.853-1.127 3.017v37.325h-3.625V93.41l.881-1.978v-19.51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.67 131.387h-3.626a.275.275 0 01-.269-.27V93.41a.313.313 0 010-.106l.858-1.931V71.922c0-.149.12-.27.269-.27h3.994a.257.257 0 01.268.27l-.128 18.853a.52.52 0 010 .094l-1.11 2.97v37.278a.275.275 0 01-.257.27zm-3.358-.54h3.089v-37.06a.295.295 0 010-.095l1.11-2.97.122-18.536h-3.457v19.247a.254.254 0 010 .111l-.858 1.925-.006 37.378z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M64.837 84.178h-3.912"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.837 84.442h-3.912a.268.268 0 01-.265-.12.271.271 0 010-.293.268.268 0 01.265-.121h3.912a.268.268 0 01.265.12.271.271 0 010 .293.268.268 0 01-.265.121z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M63.669 93.792h-3.625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.67 94.056h-3.626a.268.268 0 01-.266-.12.271.271 0 010-.293.268.268 0 01.266-.12h3.625a.268.268 0 01.266.12.271.271 0 010 .293.268.268 0 01-.266.12zM46.527 61.345a.27.27 0 01-.269-.27V58.44a.27.27 0 11.537 0v2.647a.27.27 0 01-.268.258zM63.027 61.345a.262.262 0 01-.263-.27V58.44a.27.27 0 01.12-.267.267.267 0 01.292 0 .27.27 0 01.12.267v2.647a.265.265 0 01-.269.258z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7816B",
    d: "M41.827 131.117h25.877v19.534H41.827z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.71 150.891H41.827a.263.263 0 01-.263-.264v-19.51a.27.27 0 01.263-.27H67.71a.275.275 0 01.268.27v19.534a.27.27 0 01-.268.24zm-25.597-.51h25.346v-18.994H42.113v18.994zM55.758 81.214H53.79V74.85c0-.546.981-1.426.981-1.426s.981.88.981 1.426l.006 6.363z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.758 81.507H53.79a.293.293 0 01-.292-.293V74.85c0-.646.9-1.485 1.08-1.643.11-.1.277-.1.386 0 .18.158 1.08.997 1.08 1.643v6.363c0 .16-.127.29-.286.293zm-1.67-.587h1.378v-6.069a2.301 2.301 0 00-.689-1.021 2.301 2.301 0 00-.689 1.021v6.07z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10.321 132.12h31.506v2.671H10.321z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.827 135.043h-31.53a.263.263 0 01-.262-.264v-2.67a.265.265 0 01.263-.264h31.529a.262.262 0 01.268.264v2.676a.265.265 0 01-.268.258zm-31.243-.516h30.98v-2.137h-30.98v2.137z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10.321 134.797h31.506v15.854H10.321z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.827 150.891h-31.53a.264.264 0 01-.262-.264V134.78a.265.265 0 01.263-.27h31.529a.262.262 0 01.268.27v15.848a.265.265 0 01-.268.264zm-31.243-.51h30.98v-15.338h-30.98v15.338zM40.945 132.39a.262.262 0 01-.268-.27v-31.396a.27.27 0 01.12-.266.267.267 0 01.29 0 .27.27 0 01.12.266v31.385a.265.265 0 01-.262.282zM190.679 132.109V116.43c-18.684-3.128-37.368-26.037-37.368-26.037l1.028 4.513s19.028 21.618 36.352 23.631",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.679 132.414a.293.293 0 01-.292-.294v-13.323c-17.172-2.184-36.09-23.479-36.276-23.696a.253.253 0 01-.07-.129l-.993-4.537a.306.306 0 01.152-.329.297.297 0 01.356.082c.187.223 18.836 22.856 37.199 25.926a.3.3 0 01.245.294v15.7a.291.291 0 01-.321.305zm-36.083-37.647c1.08 1.209 19.267 21.288 35.79 23.437v-1.526c-16.347-2.888-32.818-20.902-36.538-25.187l.748 3.276z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.027 132.39a.262.262 0 01-.269-.27v-14.873a.269.269 0 01.532 0v14.862a.265.265 0 01-.263.282zM178.984 132.39a.262.262 0 01-.245-.281v-17.427a.269.269 0 01.531 0v17.427a.265.265 0 01-.286.281zM172.672 132.39a.268.268 0 01-.268-.27v-21.142c0-.149.12-.27.268-.27a.27.27 0 01.269.27v21.13a.27.27 0 01-.269.282zM166.36 132.39a.262.262 0 01-.268-.27v-25.837a.269.269 0 01.531 0v25.826a.265.265 0 01-.262.282z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M146.223 53.022v-5.329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.223 53.286a.27.27 0 01-.269-.264v-5.33a.27.27 0 11.537 0v5.33a.27.27 0 01-.268.264zM146.97 54.43h-1.5l-6.475 26.79h14.456z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.445 81.507h-14.45a.289.289 0 01-.28-.358l6.474-26.783a.287.287 0 01.28-.229h1.501a.298.298 0 01.286.23l6.476 26.782a.289.289 0 01-.287.358zm-14.077-.587h13.71l-6.335-26.196h-1.04l-6.335 26.196z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M146.964 54.437h-1.489V52.43h1.489z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.964 54.724h-1.506a.293.293 0 01-.292-.293v-2.008c0-.162.13-.293.292-.293h1.483c.161 0 .292.131.292.293v2.008a.293.293 0 01-.269.293zm-1.167-.587h.899v-1.42h-.9v1.42z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7816B",
    d: "M143.064 80.34v-6.346l3.159-5.341 3.159 5.341v6.345h3.036v50.778h-12.39V80.339z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.412 131.387h-12.384a.27.27 0 01-.263-.27V80.339c0-.146.118-.264.263-.264h2.773V74c0-.047.012-.094.035-.135l3.16-5.341a.274.274 0 01.455 0l3.158 5.341a.271.271 0 01.035.135v6.08h2.768a.262.262 0 01.269.265v50.778a.27.27 0 01-.269.264zm-12.115-.54h11.852V80.609h-2.767a.27.27 0 01-.269-.27v-6.274l-2.89-4.89-2.89 4.89v6.274a.275.275 0 01-.269.27h-2.767v50.238z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M152.412 84.994h-12.384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.412 85.258h-12.384a.27.27 0 010-.534h12.384a.268.268 0 01.265.12.271.271 0 010 .293.268.268 0 01-.265.12zM148.412 94.937h1.956v-6.363c0-.546-.98-1.426-.98-1.426s-.976.88-.976 1.426v6.363zM145.242 94.937h1.968v-6.363c0-.546-.981-1.426-.981-1.426s-.981.88-.981 1.426l-.006 6.363zM142.077 94.937h1.956v-6.363c0-.546-.975-1.426-.975-1.426s-.98.88-.98 1.426v6.363zM148.412 106.87h1.956v-6.392c0-.54-.98-1.427-.98-1.427s-.976.887-.976 1.427v6.392zM145.242 106.87h1.968v-6.392c0-.54-.981-1.427-.981-1.427s-.981.887-.981 1.427l-.006 6.392zM142.077 106.87h1.956v-6.392c0-.54-.975-1.427-.975-1.427s-.98.887-.98 1.427v6.392zM148.412 118.755h1.956v-6.368c0-.546-.98-1.426-.98-1.426s-.976.88-.976 1.426v6.368zM145.242 118.755h1.968v-6.368c0-.546-.981-1.426-.981-1.426s-.981.88-.981 1.426l-.006 6.368zM142.077 118.755h1.956v-6.368c0-.546-.975-1.426-.975-1.426s-.98.88-.98 1.426v6.368z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M151.489 97.232h-10.533"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.49 97.478h-10.51a.275.275 0 01-.269-.27.27.27 0 01.269-.264h10.51a.27.27 0 01.268.264.275.275 0 01-.269.27z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M151.489 109.341h-10.533"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.49 109.61h-10.51a.268.268 0 01-.265-.12.271.271 0 010-.293.268.268 0 01.265-.12h10.51a.268.268 0 01.265.12.271.271 0 010 .293.268.268 0 01-.266.12z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M151.974 122.007h-11.502"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.974 122.271h-11.502a.27.27 0 01-.269-.264.275.275 0 01.269-.27h11.502a.275.275 0 01.269.27.27.27 0 01-.269.264zM154.473 60.612l-2.954 11.31h5.908z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.427 72.24h-5.908a.291.291 0 01-.228-.118.283.283 0 01-.053-.253l2.978-11.334a.304.304 0 01.584 0l2.92 11.31a.295.295 0 01-.047.253.303.303 0 01-.246.141zm-5.546-.588h5.15l-2.575-9.867-2.575 9.867z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7816B",
    d: "M156.365 71.922l-.123 18.853-1.127 3.017v37.325h-3.626V93.41l.882-1.978v-19.51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.115 131.387h-3.626a.275.275 0 01-.268-.27V93.41a.313.313 0 010-.106l.858-1.931V71.922c0-.149.12-.27.269-.27h3.993a.268.268 0 01.269.27l-.128 18.853a.265.265 0 010 .094l-1.098 2.97v37.278a.275.275 0 01-.269.27zm-3.357-.54h3.089v-37.06a.295.295 0 010-.095l1.11-2.97.122-18.536h-3.44v19.247a.383.383 0 010 .111l-.858 1.925-.023 37.378z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M156.283 84.178h-3.912"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.283 84.442h-3.912a.268.268 0 01-.265-.12.271.271 0 010-.293.268.268 0 01.265-.121h3.912a.268.268 0 01.265.12.271.271 0 010 .293.268.268 0 01-.265.121z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M155.115 93.792h-3.626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.115 94.056h-3.626a.268.268 0 01-.265-.12.271.271 0 010-.293.268.268 0 01.265-.12h3.626a.268.268 0 01.265.12.271.271 0 010 .293.268.268 0 01-.265.12zM137.973 60.612l2.954 11.31h-5.909z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.927 72.24h-5.909a.303.303 0 01-.233-.118.3.3 0 01-.053-.253l2.955-11.31a.304.304 0 01.584 0l2.954 11.31a.283.283 0 01-.053.253.291.291 0 01-.245.117zm-5.529-.588h5.15l-2.575-9.867-2.575 9.867z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7816B",
    d: "M136.081 71.922l.123 18.853 1.127 3.017v37.325h3.625V93.41l-.881-1.978v-19.51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.956 131.387h-3.625a.275.275 0 01-.269-.27V93.839l-1.11-2.97a.52.52 0 010-.094l-.128-18.853a.259.259 0 01.269-.27h3.993a.27.27 0 01.269.27v19.452l.858 1.931a.313.313 0 010 .106v37.706a.275.275 0 01-.257.27zm-3.357-.54h3.089V93.469l-.858-1.925a.254.254 0 010-.111V72.186h-3.48l.122 18.536 1.11 2.97a.295.295 0 010 .094l.017 37.06z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M136.163 84.178h3.912"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.075 84.442h-3.912a.268.268 0 01-.265-.12.271.271 0 010-.293.268.268 0 01.265-.121h3.912a.268.268 0 01.265.12.271.271 0 010 .293.268.268 0 01-.265.121zM140.956 94.056h-3.625a.268.268 0 01-.266-.12.271.271 0 010-.293.268.268 0 01.266-.12h3.625a.268.268 0 01.266.12.271.271 0 010 .293.268.268 0 01-.266.12z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M154.473 61.075V58.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.473 61.345a.27.27 0 01-.257-.258V58.44a.27.27 0 11.537 0v2.647a.27.27 0 01-.28.258z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M137.973 61.075V58.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.973 61.345a.262.262 0 01-.269-.27V58.44a.27.27 0 01.12-.267.267.267 0 01.291 0 .27.27 0 01.12.267v2.647a.263.263 0 01-.262.258z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7816B",
    d: "M133.29 131.117h25.877v19.534H133.29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.173 150.891H133.29a.27.27 0 01-.268-.264v-19.51a.275.275 0 01.268-.27h25.883a.27.27 0 01.263.27v19.534a.263.263 0 01-.263.24zm-25.614-.534h25.328v-18.97H133.56v18.97zM145.242 81.214h1.968V74.85c0-.546-.981-1.426-.981-1.426s-.981.88-.981 1.426l-.006 6.363z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M190.673 134.797h-31.506v-2.67h31.506z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.679 135.043h-31.53a.262.262 0 01-.268-.264v-2.67a.265.265 0 01.269-.264h31.529c.145 0 .263.118.263.264v2.676a.263.263 0 01-.263.258zm-31.243-.534h30.98v-2.136h-30.98v2.136z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M190.673 150.645h-31.506V134.79h31.506z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.679 150.891h-31.53a.262.262 0 01-.268-.264V134.78a.265.265 0 01.269-.27h31.529a.262.262 0 01.263.27v15.848a.264.264 0 01-.263.264zm-31.243-.534h30.98v-15.314h-30.98v15.314zM160.055 132.39a.262.262 0 01-.263-.27v-31.396a.27.27 0 01.12-.266.267.267 0 01.291 0 .27.27 0 01.12.266v31.385a.265.265 0 01-.268.282z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.284 151.478a.299.299 0 01-.292-.287.295.295 0 01.286-.3 10.607 10.607 0 007.894-3.926.303.303 0 01.21-.112.285.285 0 01.222.082 9.839 9.839 0 005.495 2.888 6.194 6.194 0 005.581-2.048.29.29 0 01.397-.053 7.738 7.738 0 0010.428-1.761.303.303 0 01.473 0c2.435 3.44 7.783 4.367 11.222 1.949a.28.28 0 01.386.052 4.777 4.777 0 003.55 1.62 4.704 4.704 0 003.631-1.414.303.303 0 01.251-.088c.09.013.17.067.216.147a2.622 2.622 0 003.678.775.297.297 0 01.41.058.295.295 0 01-.065.41c-.713.512-1.61.692-2.464.494a3.139 3.139 0 01-1.856-1.139 5.63 5.63 0 01-7.59-.287c-3.58 2.347-8.922 1.438-11.573-1.92a8.354 8.354 0 01-10.79 1.72 6.833 6.833 0 01-5.926 2.054 10.28 10.28 0 01-5.605-2.829 11.17 11.17 0 01-8.157 3.915h-.012zM115.75 154.067a4.209 4.209 0 01-3.053-1.174 5.817 5.817 0 01-7.882-.992 10.733 10.733 0 01-7.491 1.72.298.298 0 01-.187-.478.294.294 0 01.274-.11c2.568.374 5.18-.256 7.299-1.76a.302.302 0 01.222-.053c.076.016.145.06.192.123a5.235 5.235 0 007.415.933.285.285 0 01.216-.07.291.291 0 01.199.106 3.743 3.743 0 003.246 1.174 11.675 11.675 0 003.58-1.174.29.29 0 01.385.152c.066.148 0 .321-.146.388a12.08 12.08 0 01-3.766 1.174 4.792 4.792 0 01-.502.04zM81.577 154.6a.292.292 0 01-.286-.252.3.3 0 01.245-.334 5.322 5.322 0 003.124-1.679.303.303 0 01.204-.094.274.274 0 01.21.082c.599.628 1.4 1.02 2.26 1.11a2.365 2.365 0 002.148-.963.286.286 0 01.24-.129c.095.007.183.051.245.123a2.142 2.142 0 002.51.734.29.29 0 01.298.029.294.294 0 01-.07.511 2.757 2.757 0 01-2.972-.64 3.062 3.062 0 01-2.44.922 4.141 4.141 0 01-2.406-1.074 5.91 5.91 0 01-3.264 1.649l-.046.006z",
    fill: "#D1D3D4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationUnitedKingdom);
export default __webpack_public_path__ + "static/media/illustration-united-kingdom.70381d661f8493c11170be9122fb03ce.svg";
export { ForwardRef as ReactComponent };